import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { NavItem } from "../../styles/sharedStyles";
import { spacesOverview } from "../../urls";

// De losse ruimte-links zaten hier eerst in een hover-dropdown; die rol heeft
// de overzichtspagina op /ruimtes overgenomen.
const SpacesNavItem = () => {
  const { t } = useTranslation();

  return (
    <NavItem className="list-inline-item pe-2 ps-2 pe-xl-4 ps-xl-4">
      <Link to={spacesOverview}>{t("spaces_at_oostwest")}</Link>
    </NavItem>
  );
};

export default SpacesNavItem;
